let AbstractExporter = require('../../io/export/abstractExporter');

/**
 * Класс TopoJsonExporter
 * @extends AbstractExporter
 */
class TopoJsonExporter extends AbstractExporter {
  constructor(params){
    super(params);
  }
}

module.exports = TopoJsonExporter;